import actions from './actions';
//isKarieDUO is an indicator for identifying the current toggle selection by the users.
const initState = {
    isKarieDUO: false,
};

export default function reducer(state = initState, action) {
    switch (action.type) {
        case actions.FETCH_DEVICE_VERSION:
            return {
                ...state,
                isKarieDUO: action.payload
            };
        default:
            return state;
    }
}
